module.exports = __webpack_public_path__ + "static/media/message.42929706.svg";